export const tokenName = 'token_documalis';

export const DayMonth = {
    firstDayOfWeek: 1,
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi' ],
    dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', ],
    dayNamesMin: ['Di','Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', ],
    monthNames: [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre',
    ],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jui', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
    today: "Aujourd'hui",
    clear: 'Effacer',
    weekHeader: 'Wk',
};

export const TypeFileGed = ['application/pdf'];

export const extPdf = '.pdf';
export const extJson = '.json';
export const extGed = '.ged';

export const ExpDocks_ = 'ExportParamDocks_';
export const ExpRequests_ = 'ExportRequests_';
export const ExpResults_ = 'ExportResults_';

export const MaxUpload = 20000000;
export const FetchValue = 1000;

export const KeyDetailDocks = '@detail';

export const ext_Pdf = [extPdf];
export const ext_Ged = [extGed];
export const ext_Tiff = ['.tif', '.tiff'];
export const ext_Images = ['.jpeg', '.jpg', '.png', '.bmp', '.gif'];
export const ext_Text = [
    '.csv',
    '.txt',
    '.doc',
    '.docx',
    '.odt',
    '.ott',
    '.sxw',
    '.stw',
    '.rtf',
    '.htm',
    '.html',
    '.xml',
    '.ps',
    '.eps',
    '.rvf',
    '.dot',
    '.dotx',
    '.docm',
];
export const ext_Calc = [
    '.csv',
    '.xls',
    '.xlsx',
    '.xlt',
    '.xlsm',
    '.ods',
    '.ots',
    '.sxc',
    '.stc',
    '.htm',
    '.html',
    '.xml',
    '.xltx',
];
export const ext_Show = [
    '.ppt',
    '.pps',
    '.pptx',
    '.ppsx',
    '.potx',
    '.pot',
    '.potm',
    '.htm',
    '.html',
    '.xml',
    '.odp',
    '.otp',
];
export const ext_Mail = ['.msg', '.oft', '.eml', '.nsf'];
export const filterFormaList = 'Image,Archive,Document,Email,PDF,XML';

// Extension Alternative
export const ext_Custom: string[] = ['.zip', '.mp3', '.avi'];

// Nom requêtes système
export const sysLastDoc = 'sysLastDoc';
export const sysLastActionDoc = 'sysLastActionDoc';

export const defaultPage = 'dashboard';
export const defMenuStyle = 3;
export const defaultModeView = 'grid';
export const defaultModeViewDoc = 'ViewPdf';
export const defaultListActionDate = 'TNoDate';
export const actPdfModeViewDoc = 'ActPdf';
export const imgModeViewDoc = 'ViewImg';

export const defStatStyle = 'doughnut';
export const defStatPer = 'year';
export const defBskLoadMax = '10';
export const defReqLoadMax = '5';
export const defLoadMax = '20000000';
export const defTokenDuration = '720';
export const defTitleCustMenu = 'Ecrans personnalisés';
export const defBackGround = 'user-bg.png';
export const defLogo = 'logo.png';

export const defBskColorMail = '#84d264';
export const defBskColorCollect = '#7eb5ec';
export const defBskColorPublish = '#9c91f3';
export const defBskColorAction = '#f9c474';
export const defBskColorInput = '#9fde06';
export const defBskColorOutput = '#f1d616';
export const defBskColorSystem = '#fd7878'

// En rapport avec V5
export const reqWds = 'Wds';
export const reqTre = 'Browse';
export const reqIdx = 'Variable';
export const reqBsk = 'Basket';
export const reqBas = 'Bsk';

export const BskColorType = ['bskMailColor', 'bskCollectColor', 'bskPublishColor', 'bskActionColor', 'bskInputColor', 'bskOutputColor', 'bskSystemColor'];

export const BasTyp = ['DateTime', 'Date', 'String', 'Integer', 'Double', 'Boolean', 'TextArea', 'InputNumber'];

export const BaseType = [
    ...BasTyp,
    'DynamicIndex',
    'EditMask',
    'ListGroups',    
    'ListDB',
    'ListUsers',
    'Combo',
    'ComboCustom',
    'separator',
];

export const BasicType = [...BasTyp, 'TextArea', 'InputCurrency'];

export const InfoDoc = [
    'Docid',
    'BaseRoot',
    'StoragePath',
    'DocName',
    'Extension',
    'CreationDate',
    'Size',
    'Page',
    'Owner',
    'Crc',
    'Origin',
];

export const MenuStyle= [
    'static',
    'overlay',
    'slim',
    'horizontal',
    'slim-plus',
    'reveal',
    'drawer',
]

export const InputStyle= [
    'outlined',
    'filled',
]

export const Operators = [
    { id: 0, type: 'TEqual', name: 'Egal' },
    { id: 1, type: 'TNot', name: 'Différent' },
    { id: 2, type: 'TLike', name: 'Contient' },
    { id: 3, type: 'TNotLike', name: 'Ne contient pas' },
    { id: 4, type: 'TIn', name: 'Dans la liste' },
    { id: 5, type: 'TNotIn', name: "N'est pas dans la liste" },
    { id: 6, type: 'TLess', name: 'Inférieur' },
    { id: 7, type: 'TMore', name: 'Supérieur' },
    { id: 8, type: 'TLessOrEqu', name: 'Inférieur ou égal' },
    { id: 9, type: 'TGreatOrEqu', name: 'Supérieur ou égal' },
];

export const ActionDate = [
    { label: 'Pas de date', value: 'TNoDate' },
    { label: "Aujourd'hui", value: 'TNow' },
    { label: 'Hier', value: 'TYesterday' },
    { label: 'Avant hier', value: 'TBeforeYesterday' },
    { label: 'Demain', value: 'TTomorrow' },
    { label: 'Après demain', value: 'TPastTomorrow' },
    { label: 'Sept jours précédents', value: 'TLastWeek' },
    { label: 'Sept jours suivants', value: 'TNextWeek' },
    { label: 'Début du mois', value: 'TBeginMonth' },
    { label: 'Fin du mois', value: 'TEndMonth' },
    { label: 'Début mois précédent', value: 'TBeginPrevMonth' },
    { label: 'Fin mois précédent', value: 'TEndPrevMonth' },
    { label: 'Début mois suivant', value: 'TBeginNextMonth' },
    { label: 'Fin mois suivant', value: 'TEndNextMonth' },
    { label: "Début d'année", value: 'TBeginYear' },
    { label: "Fin d'année", value: 'TEndYear' },
    { label: 'Début année précédente', value: 'TBeginPrevYear' },
    { label: 'Fin année précédente', value: 'TEndPrevYear' },
];

export const AvailableTheme = [
    { label: 'Amber', value: 'amber' },
    { label: 'Blue', value: 'blue' },
    { label: 'Blue Grey', value: 'bluegrey' },
    { label: 'Brown', value: 'brown' },
    { label: 'Cyan', value: 'cyan' },
    { label: 'deeporange', value: 'deeporange' },
    { label: 'deeppurple', value: 'deeppurple' },
    { label: 'green', value: 'green' },
    { label: 'indigo', value: 'indigo' },
    { label: 'lightblue', value: 'lightblue' },
    { label: 'lightgreen', value: 'lightgreen' },
    { label: 'lime', value: 'lime' },
    { label: 'orange', value: 'orange' },
    { label: 'pink', value: 'pink' },
    { label: 'purple', value: 'purple' },
    { label: 'teal', value: 'teal' },
    { label: 'yellow', value: 'yellow' },
];

export const AvailableModeView = [
    { label: 'Grille', value: 'grid' },
    { label: 'Petite vignette', value: 'sthumb' },
    { label: 'Grande vignette', value: 'bthumb' },
    { label: 'Split', value: 'split' },
    { label: 'Détail', value: 'detail' },
];

export const AvailableModeViewDoc = [
    { label: 'Lecture pdf', value: defaultModeViewDoc },
    { label: 'Action pdf', value: actPdfModeViewDoc },
    { label: 'Image', value: imgModeViewDoc },
];

export const AvailableBskTabDetail = [
    { label: 'Lecture pdf', value: 'Read_Pdf' },
    { label: 'Bannette', value: 'Basket' },
    { label: 'Document', value: 'Doc_B' },
    { label: 'Suivi', value: 'Follow' },
    { label: 'Version', value: 'Version_1' },
];

export const AvailableSrcTabDetail = [
    { label: 'Lecture pdf', value: 'Read_Pdf' },
    { label: 'Document', value: 'Doc_B' },
    { label: 'Suivi', value: 'Follow' },
    { label: 'Version', value: 'Version_1' },
];

export const  AvailableMenuThemes = [
    {label: 'light', value: 'light'},
    {label: 'dark', value: 'dark'},
    {label: 'indigo', value: 'indigo'},
    {label: 'bluegrey', value: 'bluegrey'},
    {label: 'brown', value: 'brown'},
    {label: 'cyan', value: 'cyan'},
    {label: 'green', value: 'green'},
    {label: 'deeppurple', value: 'deeppurple'},
    {label: 'deeporange', value: 'deeporange'},
    {label: 'pink', value: 'pink'},
    {label: 'purple', value: 'purple'},
    {label: 'teal', value: 'teal'}
];

export const AvailableTopBarThemes = [
    {label: 'lightblue', value: 'lightblue'},
    {label: 'dark', value: 'dark'},
    {label: 'white', value: 'white'},
    {label: 'blue', value: 'blue'},
    {label: 'deeppurple', value: 'deeppurple'},
    {label: 'purple', value: 'purple'},
    {label: 'pink', value: 'pink'},
    {label: 'cyan', value: 'cyan'},
    {label: 'teal', value: 'teal'},
    {label: 'green', value: 'green'},
    {label: 'lightgreen', value: 'lightgreen'},
    {label: 'lime', value: 'lime'},
    {label: 'yellow', value: 'yellow'},
    {label: 'amber', value: 'amber'},
    {label: 'orange', value: 'orange'},
    {label: 'deeporange', value: 'deeporange'},
    {label: 'brown', value: 'brown'},
    {label: 'grey', value: 'grey'},
    {label: 'bluegrey', value: 'bluegrey'},
    {label: 'indigo', value: 'indigo'}
]

export const AvailableMenuStyle = [
    { label: 'Static', value: 0 },
    { label: 'Overlay', value: 1 },    
    { label: 'Slim', value: 2 },
    { label: 'Horizontal', value: 3 },
    { label: 'slim-plus', value: 4 },
    { label: 'reveal', value: 5 },
    { label: 'drawer', value: 6 },            
];

export const AvailableInputStyle = [
    { label: 'Outlined', value: 0 },
    { label: 'Filled', value: 1 },
];


export const AvailableStatStyle = [
    { label: 'Doughnut', value: 'doughnut' },
    { label: 'Camembert', value: 'pie' },
    { label: 'Ligne', value: 'line' },
];

export const AvailableStatPer = [
    { label: 'Par année', value: 'year' },
    { label: 'Par mois', value: 'month' },
    { label: 'Par jour', value: 'day' },
];

export const AvailableBskLoadMax = [
    { label: '5', value: '5' },
    { label: '10', value: '10' },
    { label: '15', value: '15' },
    { label: 'Toutes', value: 'all' },
];

export const AvailableReqLoadMax = [
    { label: '5', value: '5' },
    { label: '10', value: '10' },
    { label: '15', value: '15' },
];

export const AvailableScale = [
    { label: '12', value: '12' },
    { label: '13', value: '13' },
    { label: '14', value: '14' },
    { label: '15', value: '15' },
    { label: '16', value: '16' },    
];

export const AvailableLoadMax = [
    { label: '20 Mo', value: '20000000' },
    { label: '40 Mo', value: '40000000' },
    { label: '60 Mo', value: '60000000' },
    { label: '80 Mo', value: '80000000' },
    { label: '100 Mo', value: '100000000' },    
    { label: '1 Go', value: '1000000000' },    
    { label: '2 Go', value: '2000000000' },
    { label: '5 Go', value: '5000000000' },
];

export const Visibility = [
    { id: 0, type: 'TPublic', name: 'Public' },
    { id: 1, type: 'TGroup', name: 'Group' },
    { id: 2, type: 'TUser', name: 'User' },
    { id: 3, type: 'TSystem', name: 'System' },
];

export const VisibilityList = [
    { label: 'Tous', value: null },
    { label: 'Publique', value: 'Public' },
    { label: 'Groupe', value: 'Group' },
    { label: 'Utilisateur', value: 'User' },
];

export const VisibilityListSys = [...VisibilityList,
    { label: 'Système', value: 'System' },
];

export const ConditionFullText = [
    { label: 'ET', value: '0' },
    { label: 'OU', value: '1' },
];

export const actionMail = [
    { label: 'A lire', value: 0 },
    { label: 'Information', value: 1 },
    { label: 'A valider', value: 2 },
    { label: 'A traiter', value: 3 },
    { label: 'A répondre', value: 4 },
];

export const pdfNote = [
    { label: 'Note', value: 'Note' },
    { label: 'Comment', value: 'Comment' },
    { label: 'Insert', value: 'Insert' },
    { label: 'Key', value: 'Key' },
    { label: 'Help', value: 'Help' },
    { label: 'NewParagraph', value: 'NewParagraph' },
    { label: 'Paragraph', value: 'Paragraph' },
];

export const pdfColor = [
    { label: 'Aqua', value: 'Aqua' },
    { label: 'Black', value: 'Black' },
    { label: 'Blue', value: 'Blue' },
    { label: 'Fuchsia', value: 'Fuchsia' },
    { label: 'Gray', value: 'Gray' },
    { label: 'Green', value: 'Green' },
    { label: 'LtGray', value: 'LtGray' },
    { label: 'Lime', value: 'Lime' },
    { label: 'Maroon', value: 'Maroon' },
    { label: 'Navy', value: 'Navy' },
    { label: 'Olive', value: 'Olive' },
    { label: 'Purple', value: 'Purple' },
    { label: 'Red', value: 'Red' },
    { label: 'Silver', value: 'Silver' },
    { label: 'Teal', value: 'Teal' },
    { label: 'White', value: 'White' },
    { label: 'Yellow', value: 'Yellow' },
];

export const parseDate = [
    { origin: 'YYYY-MM-DD', useValue: 'yyyy-MM-dd' },
    { origin: 'DD-MMM-YYYY', useValue: 'dd MMM yyyy' },
    { origin: 'DD-MM-YY', useValue: 'dd-MM-yy' },
    { origin: 'HH:NN', useValue: 'hh:mm' },
    { origin: 'HH:NN:SS', useValue: 'hh:mm:ss' },
    { origin: 'YYYY-MM-DD HH:NN:SS', useValue: 'yyyy-MM-dd hh:mm:ss' },
    { origin: 'DD-MMM-YYYY HH:NN:SS', useValue: 'dd MMM yyyy hh:mm:ss' },
    { origin: 'DD-MM-YY HH:NN', useValue: 'dd-MM-yy hh:mm' },
    { origin: 'dd/mm/yyyy', useValue: 'yyyy-MM-dd' },
    { origin: 'yyyy-mm-dd', useValue: 'yyyy-MM-dd' },
];

export const DefaultSelect = 'Sélection';
export const RegExpIsFloat = '^[ ]*[-+]?[0-9 ]{1,}[.,]?[0-9 ]*$';
export const ADD_ID = -1;
export const EmailCtrl = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const LoginCtrl = /^[a-zA-Z0-9 \._\-@]+$/;
export const GrpNameCtrl = /^[a-zA-Z0-9 \._\-]+$/;
export const GrpLabelCtrl = /^[^:\\\/?*"<>|.]+$/;
export const RegExpDateFR = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/;

export const Current = 'current';
export const BasketParse = '<<(bsk):([A-Za-z]*)(.*)?>>';

export const indexInputMode = ['NotRequired', 'NoInput', 'Normal'];

export const Variable = [
    {
        Name: '&doc_docid',
        Label: 'Identifiant du document',
        Type: 'String',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&doc_root',
        Label: 'Racine de stockage',
        Type: 'String',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&doc_name',
        Label: 'Nom du document',
        Type: 'String',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&doc_path',
        Label: 'Chemin du document',
        Type: 'String',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&doc_creationdate',
        Label: 'Date de création',
        Type: 'DateTime',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&doc_owner',
        Label: 'Utilisateur',
        Type: 'String',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&doc_origin',
        Label: 'Origine',
        Type: 'String',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&doc_size',
        Label: 'Taille',
        Type: 'Integer',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&doc_page',
        Label: 'Nombre de page',
        Type: 'Integer',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&doc_ext',
        Label: 'Format',
        Type: 'String',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&doc_checkoutuser',
        Label: 'Verrouillage utilisateur',
        Type: 'String',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&doc_checkoutdate',
        Label: 'Date de verrouillage',
        Type: 'DateTime',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&doc_checkoutreason',
        Label: 'Raison du verrouillage',
        Type: 'String',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&doc_atfcount',
        Label: 'Nombre de pièce jointes',
        Type: 'Integer',
        Required: 'false',
        System: 'false',
    },
];

export const VariableBsk = [
    {
        Name: '&bsk_docdate',
        Label: 'Date de la bannette',
        Type: 'DateTime',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&bsk_docstatus',
        Label: 'Statut',
        Type: 'String',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&bsk_mailaction',
        Label: 'Action',
        Type: 'ComboCustom',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&bsk_maillimit',
        Label: 'Date limite',
        Type: 'DateTime',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&bsk_mailurgent',
        Label: 'Urgent',
        Type: 'Boolean',
        Required: 'false',
        System: 'false',
    },
    {
        Name: '&bsk_mailconf',
        Label: 'Confidentiel',
        Type: 'Boolean',
        Required: 'false',
        System: 'false',
    }
]

export const InfosDoc = [
    { id: 'BaseRoot', Name: '&doc_root' },
    { id: 'CheckoutDate', Name: '&doc_checkoutdate' },
    { id: 'CheckoutReason', Name: '&doc_checkoutreason' },
    { id: 'CheckoutUser', Name: '&doc_checkoutuser' },
    { id: 'CreationDate', Name: '&doc_creationdate' },
    { id: 'Docid', Name: '&doc_docid' },
    { id: 'Extension', Name: '&doc_ext' },
    { id: 'Name', Name: '&doc_name' },
    { id: 'Origin', Name: '&doc_origin' },
    { id: 'Owner', Name: '&doc_owner' },
    { id: 'Page', Name: '&doc_page' },
    { id: 'Size', Name: '&doc_size' },
    { id: 'StoragePath', Name: '&doc_path' },
    { id: 'Crc', Name: '&doc_cksum' },
];

export const doc_docid = {
    name: '&doc_docid',
    type: 'String',
    label: 'DocId',
    sort: -1,
    typeorder: 0,
    thumbinfo: 0,
};

export const doc_name = {
    name: '&doc_name',
    type: 'String',
    label: 'Nom',
    sort: -1,
    typeorder: 0,
    thumbinfo: 0,
};

export const doc_creationdate = {
    name: '&doc_creationdate',
    type: 'DateTime',
    label: 'Date',
    sort: -1,
    typeorder: 0,
    thumbinfo: 0,
};

export const doc_root = {
    name: '&doc_root',
    type: 'String',
    label: 'Racine',
    sort: -1,
    typeorder: 0,
    thumbinfo: 0,
};

export const doc_path = {
    name: '&doc_path',
    type: 'String',
    label: 'Dossier',
    sort: -1,
    typeorder: 0,
    thumbinfo: 0,
};

export const doc_ext = {
    name: '&doc_ext',
    type: 'String',
    label: 'Extension',
    sort: -1,
    typeorder: 0,
    thumbinfo: 0,
};

export const doc_page = {
    name: '&doc_page',
    type: 'Integer',
    label: 'Nombre de page',
    sort: -1,
    typeorder: 0,
    thumbinfo: 0,
};

export const doc_size = {
    name: '&doc_size',
    type: 'Integer',
    label: 'Taille',
    sort: -1,
    typeorder: 0,
    thumbinfo: 0,
};

export const bsk_docdate = {
    name: '&bsk_docdate',
    type: 'DateTime',
    label: 'Date de la bannette',
    sort: 0,
    typeorder: 0,
    thumbinfo: 0,
};

export const doc_atfcount = {
    name: '&doc_atfcount',
    type: 'String',
    label: 'Pièces jointes',
    sort: -1,
    typeorder: 0,
    thumbinfo: 0,
};

export const bsk_docstatus = {
    name: '&bsk_docstatus',
    type: 'String',
    label: 'Statut',
    sort: -1,
    typeorder: 0,
    thumbinfo: 0,
};

export const bsk_maillimit = {
    name: '&bsk_maillimit',
    type: 'DateTime',
    label: 'Date limite',
    sort: -1,
    typeorder: 0,
    thumbinfo: 0,
};

export const bsk_mailurgent = {
    name: '&bsk_mailurgent',
    type: 'Boolean',
    label: 'Urgent',
    sort: -1,
    typeorder: 0,
    thumbinfo: 0,
};

export const bsk_mailconf = {
    name: '&bsk_mailconf',
    type: 'Boolean',
    label: 'Confidentiel',
    sort: -1,
    typeorder: 0,
    thumbinfo: 0,
};

export const bsk_delay = {
    name: '&bsk_delay',
    type: 'Integer',
    label: 'Délai',
    sort: -1,
    typeorder: 0,
    thumbinfo: 0,
};

export const bsk_mailaction = {
    name: '&bsk_mailaction',
    type: 'Integer',
    label: 'Action',
    sort: -1,
    typeorder: 0,
    thumbinfo: 0,
};
